const validate = (values) => {
    const errors = {};
   
    if (!values.name) {
        errors.name = "Institution name is a required parameter";
    }
    if (values.subscriberId && !/^(\d{11})$/.test(values.subscriberId)) {
        errors.subscriberId = "Invalid phone number (Must be 11 digits)";
    }
    if (!values.fepCode) {
        errors.fepCode = "Please select an fep";
      }
    if (!values.cardPan) {
        errors.cardPan = "Card Number field cannot be empty";
    } else {
        if(values.cardPan && (values.cardPan.length < 16 || values.cardPan.length > 19)) {
            errors.cardPan = "Invalid Card Number. It should not be less than 16 digits or more than 19 digits"
        } else if(values.cardPan && values.cardPan.length > 16 && values.cardPan.length < 19) {
            errors.cardPan = "Invalid Card Number. It should not be less than 16 digits or more than 19 digits"
        }
    }
    if (!values.pin) {
        errors.pin = "Pin field cannot be empty";
    } 
    if(values.pin && !/^(\d{4})$/.test(values.pin)) {
        errors.pin = "Invalid pin"
    }
    
    if (!values.cvv) {
        errors.cvv = "cvv field cannot be empty";
    } 
    if(values.cvv && !/^(\d{3})$/.test(values.cvv)) {
        errors.cvv = "Invalid cvv"
    }

    return errors;
};

export default validate;
